import React, { FC, ReactNode, createContext, useContext, useState } from 'react';

type AssociatedPartnerContextProps = {
  partnerData: PartnerData | undefined;
  setPartnerData: React.Dispatch<React.SetStateAction<PartnerData | undefined>>
};

const AssociatedPartnerContext = createContext<AssociatedPartnerContextProps>({ partnerData: undefined, setPartnerData: () => {} });

const AssociatedPartnerProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [partnerData, setPartnerData] = useState<PartnerData | undefined>();

  return <AssociatedPartnerContext.Provider value={{ partnerData, setPartnerData }}>{children}</AssociatedPartnerContext.Provider>;
};

const useAssociatedPartnerData = () => useContext(AssociatedPartnerContext);

export { useAssociatedPartnerData, AssociatedPartnerProvider };
